 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~904afd0e":"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~904afd0e","absent_list":"absent_list","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e","area":"area","bank":"bank","country":"country","department":"department","designation":"designation","employees":"employees","ex-employees":"ex-employees","leave":"leave","leave_type":"leave_type","month":"month","pf_transaction":"pf_transaction","shift":"shift","transaction":"transaction","user_management":"user_management","attendance_log":"attendance_log","attendance_report":"attendance_report","attendance_summary_report":"attendance_summary_report","bonus_generate":"bonus_generate","bonus_report":"bonus_report","bonus_sheet":"bonus_sheet","company_profile~employee":"company_profile~employee","employee":"employee","increment":"increment","late_list":"late_list","leave_list":"leave_list","leaves":"leaves","loan":"loan","loan_adjustment":"loan_adjustment","loan_balance_report":"loan_balance_report","loan_statement":"loan_statement","loans":"loans","manual-attendances":"manual-attendances","pay_slip":"pay_slip","pf_balance_report":"pf_balance_report","pf_ledger":"pf_ledger","pf_transaction_record":"pf_transaction_record","present_list":"present_list","promotion":"promotion","salary_generate":"salary_generate","salary_report":"salary_report","salary_sheet":"salary_sheet","shift_management":"shift_management","transaction_record":"transaction_record","access_denied":"access_denied","attendance-process":"attendance-process","company_profile":"company_profile","employee-details":"employee-details","holiday_management":"holiday_management","notice":"notice"}[chunkId]||chunkId) + "." + {"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~904afd0e":"fac7fa5c","absent_list":"70fcc398","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"7ceb022e","area":"3f77dffe","bank":"fc298e1b","country":"f4c9f770","department":"a94a4977","designation":"b2137c51","employees":"50aed573","ex-employees":"e52c29f2","leave":"e0549c0d","leave_type":"22bd9095","month":"7b4c3d73","pf_transaction":"458c2477","shift":"d3dbd464","transaction":"bfe7f992","user_management":"d7d80e4e","attendance_log":"32267544","attendance_report":"e0f695cc","attendance_summary_report":"f9726cdc","bonus_generate":"e2e98cc7","bonus_report":"ef7a8419","bonus_sheet":"50f50261","company_profile~employee":"804713b5","employee":"202bbf1b","increment":"328d2dd3","late_list":"873505a6","leave_list":"9d31c4b4","leaves":"141e17ac","loan":"59d4513b","loan_adjustment":"017ea418","loan_balance_report":"99733ed3","loan_statement":"49113286","loans":"1668ee9d","manual-attendances":"d3da556e","pay_slip":"451b9e19","pf_balance_report":"706a1350","pf_ledger":"91b6c689","pf_transaction_record":"ab206e6c","present_list":"21fc8b69","promotion":"597714ce","salary_generate":"27cf6f27","salary_report":"5c32d174","salary_sheet":"8faf1d6e","shift_management":"5c5f2253","transaction_record":"95001b0e","access_denied":"b361077f","attendance-process":"4abfe799","chunk-5442ff1e":"5c9676bb","company_profile":"d59567e1","employee-details":"00cc8175","holiday_management":"24abed43","notice":"2fd5fda0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~904afd0e":1,"absent_list":1,"area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":1,"area":1,"bank":1,"country":1,"department":1,"designation":1,"employees":1,"ex-employees":1,"leave":1,"leave_type":1,"month":1,"pf_transaction":1,"shift":1,"transaction":1,"user_management":1,"attendance_log":1,"attendance_report":1,"attendance_summary_report":1,"bonus_generate":1,"bonus_report":1,"bonus_sheet":1,"company_profile~employee":1,"employee":1,"increment":1,"late_list":1,"leave_list":1,"leaves":1,"loan":1,"loan_adjustment":1,"loan_balance_report":1,"loan_statement":1,"loans":1,"manual-attendances":1,"pay_slip":1,"pf_balance_report":1,"pf_ledger":1,"pf_transaction_record":1,"present_list":1,"promotion":1,"salary_generate":1,"salary_report":1,"salary_sheet":1,"shift_management":1,"transaction_record":1,"attendance-process":1,"chunk-5442ff1e":1,"company_profile":1,"employee-details":1,"holiday_management":1,"notice":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~904afd0e":"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~904afd0e","absent_list":"absent_list","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e","area":"area","bank":"bank","country":"country","department":"department","designation":"designation","employees":"employees","ex-employees":"ex-employees","leave":"leave","leave_type":"leave_type","month":"month","pf_transaction":"pf_transaction","shift":"shift","transaction":"transaction","user_management":"user_management","attendance_log":"attendance_log","attendance_report":"attendance_report","attendance_summary_report":"attendance_summary_report","bonus_generate":"bonus_generate","bonus_report":"bonus_report","bonus_sheet":"bonus_sheet","company_profile~employee":"company_profile~employee","employee":"employee","increment":"increment","late_list":"late_list","leave_list":"leave_list","leaves":"leaves","loan":"loan","loan_adjustment":"loan_adjustment","loan_balance_report":"loan_balance_report","loan_statement":"loan_statement","loans":"loans","manual-attendances":"manual-attendances","pay_slip":"pay_slip","pf_balance_report":"pf_balance_report","pf_ledger":"pf_ledger","pf_transaction_record":"pf_transaction_record","present_list":"present_list","promotion":"promotion","salary_generate":"salary_generate","salary_report":"salary_report","salary_sheet":"salary_sheet","shift_management":"shift_management","transaction_record":"transaction_record","access_denied":"access_denied","attendance-process":"attendance-process","company_profile":"company_profile","employee-details":"employee-details","holiday_management":"holiday_management","notice":"notice"}[chunkId]||chunkId) + "." + {"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~904afd0e":"c48a28e3","absent_list":"84cd72a6","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"5ffd811a","area":"033200ff","bank":"033200ff","country":"033200ff","department":"033200ff","designation":"033200ff","employees":"f50617b6","ex-employees":"a1003375","leave":"3c59c7a7","leave_type":"033200ff","month":"033200ff","pf_transaction":"571c0593","shift":"7bd1a9ce","transaction":"5489a904","user_management":"35298fd3","attendance_log":"18c155b3","attendance_report":"eda504f5","attendance_summary_report":"52fee94d","bonus_generate":"2588119f","bonus_report":"b41f3de3","bonus_sheet":"178e9895","company_profile~employee":"6df1f26b","employee":"2d28794b","increment":"ca3b45a4","late_list":"d3a60c73","leave_list":"deed58dc","leaves":"f804fe21","loan":"d085a351","loan_adjustment":"e283fa07","loan_balance_report":"c913fd4c","loan_statement":"5837fa65","loans":"55695889","manual-attendances":"49830f27","pay_slip":"a32d7ddb","pf_balance_report":"ac54e4a9","pf_ledger":"1d600b57","pf_transaction_record":"3e87383f","present_list":"3eddfd9a","promotion":"573597f8","salary_generate":"a98f0a50","salary_report":"bdf753a1","salary_sheet":"84cd2151","shift_management":"60156431","transaction_record":"828ee88e","access_denied":"31d6cfe0","attendance-process":"786d522a","chunk-5442ff1e":"218e3bfd","company_profile":"4fa657a9","employee-details":"da00aa01","holiday_management":"b39b2cc2","notice":"5675ced1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://hr.bizmanagerbd.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
